import { render, staticRenderFns } from "./InfoMessage.vue?vue&type=template&id=f881432c&scoped=true"
import script from "./InfoMessage.vue?vue&type=script&lang=js"
export * from "./InfoMessage.vue?vue&type=script&lang=js"
import style0 from "./InfoMessage.vue?vue&type=style&index=0&id=f881432c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f881432c",
  null
  
)

export default component.exports